import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { MobileCaptureShell } from '../components/MobileCaptureShell'
import { pairMobileCapture } from '../mobileCaptureApi'
import './MobileCapturePage.css'

/** QR entry — exchange once, then strip token from the URL. */
export default function MobileCapturePairPage() {
  const { token = '' } = useParams<{ token: string }>()
  const navigate = useNavigate()
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    let cancelled = false
    ;(async () => {
      if (!token || token.length < 16) {
        setError('无效的二维码链接')
        return
      }
      try {
        await pairMobileCapture(token)
        if (cancelled) return
        navigate('/mobile-capture', { replace: true })
      } catch (e) {
        if (cancelled) return
        setError((e as Error).message || '扫码失败，请在电脑上重新生成二维码')
      }
    })()
    return () => {
      cancelled = true
    }
  }, [token, navigate])

  if (error) {
    return (
      <MobileCaptureShell>
      <div className="mc-page">
        <header className="mc-header">
          <div className="mc-brand">VISTOERA</div>
          <h1>无法进入拍照</h1>
        </header>
        <div className="mc-banner mc-banner-error">{error}</div>
        <p className="mc-subtitle">请回到电脑端「图片资产 → 手机上传」重新生成二维码，或打开登录页。</p>
        <button type="button" className="mc-big-button mc-primary" onClick={() => navigate('/mobile-capture', { replace: true })}>
          前往登录
        </button>
      </div>
      </MobileCaptureShell>
    )
  }

  return (
    <MobileCaptureShell>
    <div className="mc-page">
      <header className="mc-header">
        <div className="mc-brand">VISTOERA</div>
        <h1>正在连接…</h1>
        <p className="mc-subtitle">正在验证扫码授权</p>
      </header>
    </div>
    </MobileCaptureShell>
  )
}
